import isEmail from 'isemail';

export function isValidEmail(email: string) {
  return isEmail.validate(email, { minDomainAtoms: 2 });
}
